import str_plural from '../../helpers/str_plural';
import {IApiRouteNamesResolver} from '../../@interfaces/services/NameResolvers/IApiRouteNamesResolver';
import {snake_case} from '../../helpers/string-registres';

export default class ApiRouteNamesResolver implements IApiRouteNamesResolver {
    static DEFAULT_BASE_MODEL_NAME = 'abstract-models';

    static INDEX_ROUTE_NAME = 'index';
    static SHOW_ROUTE_NAME = 'show';
    static UPDATE_ROUTE_NAME = 'update';
    static CREATE_ROUTE_NAME = 'store';
    static DELETE_ROUTE_NAME = 'destroy';
    static RESTORE_ROUTE_NAME = 'restore';
    static INDEX_ORDER_NUMBER_ROUTE_NAME = 'order-number.index';
    static UPDATE_ORDER_NUMBER_ROUTE_NAME = 'order-number.update';

    getDefaultBaseModelName(): string {
        return ApiRouteNamesResolver.DEFAULT_BASE_MODEL_NAME;
    }

    getIndexRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'INDEX_ROUTE_NAME');
    }

    getShowRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'SHOW_ROUTE_NAME');
    }

    getCreateRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'CREATE_ROUTE_NAME');
    }

    getUpdateRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'UPDATE_ROUTE_NAME');
    }

    getDeleteRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'DELETE_ROUTE_NAME');
    }

    getRestoreRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'RESTORE_ROUTE_NAME');
    }

    getRecordsToSortRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'INDEX_ORDER_NUMBER_ROUTE_NAME');
    }

    getUpdateRecordsOrderNumberRouteName(modelName?: string | null): string {
        return this.resolve(modelName, 'UPDATE_ORDER_NUMBER_ROUTE_NAME');
    }

    resolveRouteName(modelName: string | null | undefined, endpointName: string): string {
        return this.resolveName(modelName, endpointName);
    }

    protected resolve(
        modelName: string | null | undefined,
        constantName: Exclude<keyof typeof ApiRouteNamesResolver, 'DEFAULT_BASE_MODEL_NAME' | 'prototype'>
    ): string {
        return this.resolveName(modelName, ApiRouteNamesResolver[constantName]);
    }

    protected resolveName(modelName: string | null | undefined, endpointName: string): string {
        if (modelName == null) {
            modelName = this.getDefaultBaseModelName();
        } else {
            modelName = snake_case(str_plural(modelName), '-');
        }

        return modelName + '.' + endpointName;
    }
}
